export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_19.c80460f9.jpg";